<template>
  <div class="box">
    <tablePackaging
      :tableListData="postList"
      :tableOption.sync="tableOption"
      :isOperate="isOperate"
      :page="page"
      :searchFormList="searchFormList"
      @update="getTableChangePageData"
      @searchDate="getTableData"
    >
      <!-- <template v-slot:header>
        <div class="btn-wrap">
          <div class="left-wrap"></div>
          <div class="right-wrap">
            <el-button type="primary" @click="handelClickAdd" size="small"
              >添加</el-button
            >
          </div>
        </div>
      </template> -->
      <template slot-scope="scope" slot="operate">
        <el-tooltip
          class="item"
          popper-class="popper-class"
          content="编辑"
          placement="bottom-end"
        >
          <!-- v-if="scope.row.username != 'admin'" -->
          <el-button
            icon="el-icon-edit-outline"
            circle
            size="20"
            type="success"
            @click="handelClickEdit(scope.row)"
          ></el-button>
        </el-tooltip>
      </template>
    </tablePackaging>
    <upDataFormPackaging
      ref="upDataFormPackaging"
      :editFormDefaulteArr="editFormDefaulteArr"
      @editUpData="editItemMsg"
      :title="title"
    ></upDataFormPackaging>
  </div>
</template>

<script>
import { query, update } from '@/api/store';
import tablePackaging from '@/components/tablePackaging';
import upDataFormPackaging from '@/components/upDataFormPackaging';
import { clone } from '@/utils/utils';

const defaultSearchObj = {
  pageNum: 1,
  pageSize: 10,
};
const defaultEditFormDefaulteArr = [
  {
    fieldName: 'storeName', //字段
    type: 'input', //类型
    name: '小程序主体企业', //名字
    size: 'long-inp', //尺寸
    maxLength: '200', //最大长度
    required: true, //是否必填
    value: '', //默认值
  },
  {
    fieldName: 'contractName', //字段
    type: 'input', //类型
    name: '负责人', //名字
    size: 'long-inp', //尺寸
    maxLength: '200', //最大长度
    required: true, //是否必填
    value: '', //默认值
  },
  {
    fieldName: 'markingTel', //字段
    type: 'input', //类型
    name: '客服电话', //名字
    size: 'long-inp', //尺寸
    maxLength: '200', //最大长度
    required: true, //是否必填
    value: '', //默认值
  },
];
export default {
  data() {
    return {
      title: '领区',
      flavorBid: '',
      postList: [],
      isOperate: true,
      editFormDefaulteArr: clone(defaultEditFormDefaulteArr),
      searchFormList: [],
      tableOption: [
        //是否展示多选
        // {
        //   type: 'selection',
        //   label: '#',
        // },
        {
          prop: 'storeName',
          label: '小程序主体企业',
          overHidden: true,
          //sortable: 'orgName',
        },
        {
          prop: 'contractName',
          label: '负责人',
          overHidden: true,
          //sortable: 'name',
        },
        {
          prop: 'markingTel',
          label: '客服电话',
          overHidden: true,
          //sortable: 'name',
          // width: 300,
        },
      ],
      searchObj: clone(defaultSearchObj),

      page: {
        pageNum: 1, //起始位置
        pageSize: 10, //每页条数
        totalCount: null, //总条数
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      query(this.searchObj).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.postList = res.data.records;
          this.page.pageNum = res.data.pageNum;
          this.page.pageSize = res.data.pageSize;
          this.page.totalCount = res.data.total;
        }
      });
    },
    getTableChangePageData(obj) {
      this.searchObj.pageNum = obj.pageNum;
      this.searchObj.pageSize = obj.pageSize;
      this.getTableData();
    },
    //添加
    handelClickAdd() {
      this.title = '新建领区';
      this.editFormDefaulteArr = clone(defaultEditFormDefaulteArr);
      console.log(this.editFormDefaulteArr);
      this.flavorBid = '';
      this.$refs.upDataFormPackaging.DialogShow = true;
    },
    //修改
    handelClickEdit(row) {
      this.title = '修改客服电话';
      // this.flavorBid = row.flavorBid;
      this.editFormDefaulteArr.forEach((item) => {
        for (var key in row) {
          if (key == item.fieldName) {
            item.value = row[key];
            console.log(item);
          }
        }
      });
      this.$refs.upDataFormPackaging.DialogShow = true;
    },
    //删除
    handleDelete(row) {
      this.$myConfirm
        .showMsgBox({
          title: '提示',
          // confirmBtnText: '一并删除',
          // cancelBtnText: '仅删除账号',
          tips: '',
          content: '确定删除该领区？',
        })
        .then(() => {
          deleteFlavor(row.flavorBid).then((res) => {
            if (res.code == '200') {
              this.$msg.success('删除成功！');
              this.getTableData();
            } else {
              this.$msg.error(res.msg);
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.$msg.error(res.msg);
        });
    },
    editItemMsg(data) {
      update(data)
        .then((res) => {
          if (res.code == '200') {
            this.$refs.upDataFormPackaging.closeDialog();
            this.$msg.success('修改成功！');
            this.getTableData();
          }
          this.$refs.upDataFormPackaging.upDataMsg = '保存';
        })
        .catch(() => {
          this.$refs.upDataFormPackaging.upDataMsg = '保存';
          this.$msg.error(res.msg);
        });
    },
    upTransposition(row) {
      console.log(row);

      continentMoveUp(row.continentBid).then((res) => {
        if (res.code == 200) {
          this.$msg.success('操作成功！');
          this.getTableData();
        }
      });
      // if(row.rank -1  == 0){
      //   this.$msg('已经到顶了，无法上移！')
      // }
    },
    downTransposition(row) {
      continentMoveDown(row.continentBid).then((res) => {
        if (res.code == 200) {
          this.$msg.success('操作成功！');
          this.getTableData();
        }
      });
    },
  },
  components: {
    tablePackaging,
    upDataFormPackaging,
  },
};
</script>

<style>
</style>